import ListeExerciceComptable from '@/views/compta/exerciceComptable/l_exerciceComptable';
import EditExerciceComptable from '@/views/compta/exerciceComptable/m_exerciceComptable';
import ListeJournalEcriture from '@/views/compta/journalEcriture/l_journalEcriture';
import LotsComptable from '@/views/compta/lotsComptable/l_lotsComptable';
import DetailLotsComptable from '@/views/compta/lotsComptable/c_detailLotComptable';
import ListeSituation from '@/views/compta/situation/l_situation';
import ListeOperationDiverse from '@/views/compta/operationDiverse/l_operationDiverse';
import AddOrEditOperationDiverse from '@/views/compta/operationDiverse/m_operationDiverse';
import DetailOperationDiverse from '@/views/compta/operationDiverse/c_operationDiverse';
import ListeEcritureComptable from '@/views/compta/ecritureComptable/l_ecritureComptable';

export default [
  {
    path: '/exerciceComptable',
    component: ListeExerciceComptable,
    name: 'l.parametrage.exercice_comptable',
  },
  {
    path: '/editExerciceComptable/:id',
    component: EditExerciceComptable,
    name: 'm.parametrage.exercice_comptable-edit',
  },
  {
    path: '/addExerciceComptable',
    component: EditExerciceComptable,
    name: 'm.parametrage.exercice_comptable-add',
  },
  {
    path: '/journalEcriture',
    component: ListeJournalEcriture,
    name: 'l.comptabilite.journal_ecriture',
    props: true,
  },
  {
    path: '/lotsComptable',
    component: LotsComptable,
    name: 'l.comptabilite.lots_comptable',
  },
  {
    path: '/lotsComptable/:id',
    component: DetailLotsComptable,
    name: 'c.comptabilite.lots_comptable',
  },
  {
    path: '/listeSituation',
    component: ListeSituation,
    name: 'l.comptabilite.situation',
  },
  {
    path: '/operationsDiverses/:idsOd?',
    component: ListeOperationDiverse,
    name: 'l.comptabilite.operation_diverse',
  },
  {
    path: '/detailOperationDiverse/:id',
    component: DetailOperationDiverse,
    name: 'c.comptabilite.operation_diverse',
  },
  {
    path: '/editOperationDiverse/:id',
    component: AddOrEditOperationDiverse,
    name: 'm.comptabilite.operation_diverse-edit',
  },
  {
    path: '/addOperationDiversee',
    component: AddOrEditOperationDiverse,
    name: 'm.comptabilite.operation_diverse-add',
  },
  {
    path: '/ecrituresComptables',
    component: ListeEcritureComptable,
    name: 'l.comptabilite.ecriture_comptable',
  },
];
